import * as React from 'react';
import {IBaseView} from "../../_base/base-view";
import {inject, observer} from "mobx-react";
import {UsergroupRight} from "../../../models/rights/enum-usergrouprights";
import {TableGrid} from "../../_base/styled/table-grid";
import {TableLayout} from "../../_base/styled/layout/table-layout";

@inject('rootStore')
@observer
export class InspectionPlanTableView extends React.Component<IBaseView, {}> {

    render() {
        const {rootStore: {inspectionPlanStore: {ds}, authStore: {hasUserRight}}} = this.props;
        return (
            <TableLayout>
                <TableGrid
                    id="inspectionplan"
                    icon="clipboard-check"
                    title='INSPECTION_PLANS'
                    ds={ds}
                    singleRouteName='inspectionplan'
                    hideInsert={!hasUserRight(UsergroupRight.UR_INSPECTION_PLAN_INSERT)}
                    hideDelete={!hasUserRight(UsergroupRight.UR_INSPECTION_PLAN_DELETE)}
                />
            </TableLayout>
        )
    }
}